import { render, staticRenderFns } from "./anularRegistro.vue?vue&type=template&id=1a27e45f&"
import script from "./anularRegistro.vue?vue&type=script&lang=js&"
export * from "./anularRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports